let baseUrl = null
switch (process.env.VUE_APP_CURENV) {
  case 'alpha':   // 注意这里的名字要和步骤二中设置的环境名字对应起来
    baseUrl = "http://47.100.125.152:9902/"  //这里是测试环境中的url
    break
  case 'production':
    baseUrl = "https://flh5api.51chashugu.com/"   //生产环境url
    // baseUrl = "http://mobileapi.chedaiol.com/h5"   //生产环境url
    break
  default:
    baseUrl = "http://47.100.125.152:9902/"  //这里是本地的请求url
}

export default baseUrl;